import { useRequestGetVerificationsCount } from '@/hooks/httpRequest';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { VerificationTypesEnum } from '@/lib/enum';
import useUrlParams from './useUrlParams';

const useCertificationCount = () => {

  const { gender } = useUrlParams();
  const result = useRequestGetVerificationsCount(
    {
      additionalCheckStatus: VerificationAdditionalCheckStatusEnum.WITHOUT_STATE,
      type: VerificationTypesEnum.IDENTITY
    },
    !!gender
  );

  return result;

};

export default useCertificationCount;
